import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_user/coaching")({
  staticData: { title: "My coaching team" },
  component: () => <Outlet />,
});
